<template>
    <div class="rating-area">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-6 col-sm-6">
                    <div class="card-box-style mb-24">
                        <div class="others-title">
                            <h3>Start Rating</h3>
                        </div>

                        <div class="star-rating">
                            <input id="star-5" type="radio" name="rating" value="star-5" />
                            <label for="star-5" title="5 stars">
                                <i class="active bx bxs-star" aria-hidden="true"></i>
                            </label>
                            
                            <input id="star-4" type="radio" name="rating" value="star-4" />
                            <label for="star-4" title="4 stars">
                                <i class="active bx bxs-star" aria-hidden="true"></i>
                            </label>

                            <input id="star-3" type="radio" name="rating" value="star-3" />
                            <label for="star-3" title="3 stars">
                                <i class="active bx bxs-star" aria-hidden="true"></i>
                            </label>

                            <input id="star-2" type="radio" name="rating" value="star-2" />
                            <label for="star-2" title="2 stars">
                                <i class="active bx bxs-star" aria-hidden="true"></i>
                            </label>

                            <input id="star-1" type="radio" name="rating" value="star-1" />
                            <label for="star-1" title="1 star">
                                <i class="active bx bxs-star" aria-hidden="true"></i>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-sm-6">
                    <div class="card-box-style mb-24">
                        <div class="others-title">
                            <h3>Heart Rating</h3>
                        </div>

                        <div class="star-rating">
                            <input id="heart-5" type="radio" name="rating" value="heart-5" />
                            <label for="heart-5" title="5 heart">
                                <i class="active bx bxs-heart" aria-hidden="true"></i>
                            </label>
                            
                            <input id="heart-4" type="radio" name="rating" value="heart-4" />
                            <label for="heart-4" title="4 heart">
                                <i class="active bx bxs-heart" aria-hidden="true"></i>
                            </label>

                            <input id="heart-3" type="radio" name="rating" value="heart-3" />
                            <label for="heart-3" title="3 heart">
                                <i class="active bx bxs-heart" aria-hidden="true"></i>
                            </label>

                            <input id="heart-2" type="radio" name="rating" value="heart-2" />
                            <label for="heart-2" title="2 heart">
                                <i class="active bx bxs-heart" aria-hidden="true"></i>
                            </label>

                            <input id="heart-1" type="radio" name="rating" value="heart-1" />
                            <label for="heart-1" title="1 heart">
                                <i class="active bx bxs-heart" aria-hidden="true"></i>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-sm-6">
                    <div class="card-box-style mb-24">
                        <div class="others-title">
                            <h3>Like Rating</h3>
                        </div>

                        <div class="star-rating">
                            <input id="like-5" type="radio" name="rating" value="like-5" />
                            <label for="like-5" title="5 like">
                                <i class="active bx bxs-like" aria-hidden="true"></i>
                            </label>
                            
                            <input id="like-4" type="radio" name="rating" value="like-4" />
                            <label for="like-4" title="4 like">
                                <i class="active bx bxs-like" aria-hidden="true"></i>
                            </label>

                            <input id="like-3" type="radio" name="rating" value="like-3" />
                            <label for="like-3" title="3 like">
                                <i class="active bx bxs-like" aria-hidden="true"></i>
                            </label>

                            <input id="like-2" type="radio" name="rating" value="like-2" />
                            <label for="like-2" title="2 like">
                                <i class="active bx bxs-like" aria-hidden="true"></i>
                            </label>

                            <input id="like-1" type="radio" name="rating" value="like-1" />
                            <label for="like-1" title="1 like">
                                <i class="active bx bxs-like" aria-hidden="true"></i>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-sm-6">
                    <div class="card-box-style mb-24">
                        <div class="others-title">
                            <h3>Circle Rating</h3>
                        </div>

                        <div class="star-rating">
                            <input id="circle-5" type="radio" name="rating" value="circle-5" />
                            <label for="circle-5" title="5 circle">
                                <i class="active bx bxs-circle" aria-hidden="true"></i>
                            </label>
                            
                            <input id="circle-4" type="radio" name="rating" value="circle-4" />
                            <label for="circle-4" title="4 circle">
                                <i class="active bx bxs-circle" aria-hidden="true"></i>
                            </label>

                            <input id="circle-3" type="radio" name="rating" value="circle-3" />
                            <label for="circle-3" title="3 circle">
                                <i class="active bx bxs-circle" aria-hidden="true"></i>
                            </label>

                            <input id="circle-2" type="radio" name="rating" value="circle-2" />
                            <label for="circle-2" title="2 circle">
                                <i class="active bx bxs-circle" aria-hidden="true"></i>
                            </label>

                            <input id="circle-1" type="radio" name="rating" value="circle-1" />
                            <label for="circle-1" title="1 circle">
                                <i class="active bx bxs-circle" aria-hidden="true"></i>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RatingContent'
}
</script>

<style lang="scss">
.star-rating {
	direction: rtl;
	display: inline-block;
	padding: 20px;
	cursor: default;
	input[type="radio"] {
		display: none;
	}
	label {
		color: #bbb;
		font-size: 2rem;
		padding: 0;
		cursor: pointer;
		-webkit-transition: all 0.3s ease-in-out;
		transition: all 0.3s ease-in-out;
	}
	label:hover,
	label:hover ~ label,
	input[type="radio"]:checked ~ label {
		color: #f2b600;
	}
}
</style>